import FeeBasedInstantTransferRouter from 'features/feeBasedInstantTransfer/FeeBasedInstantTransferRouter';
import FeeBasedInstantTransferEntryScreen from 'features/feeBasedInstantTransfer/screens/FeeBasedInstantTransferEntry/FeeBasedInstantTransferEntryScreen';

export default function FeeBasedInstantTransferRoute() {
  return (
    <FeeBasedInstantTransferRouter>
      <FeeBasedInstantTransferEntryScreen />
    </FeeBasedInstantTransferRouter>
  );
}
